import { useI18n } from '../i18n';

interface Props {
  value: boolean | null;
  onChange: (value: boolean) => void;
  labelledBy: string;
  describedBy?: string;
}

// 0026's frontend (spec §12.G, §14.10): the check-in's closing Safety Valve
// question. Same tile/ARIA pattern as ConcernTags (tap-only by design, same
// as the concern card — DESIGN_GUIDELINES.md on why a sensitive choice here
// is tap, not swipe), but mutually exclusive (role="radiogroup") rather than
// multi-select, and with no server-curated option list — just a fixed yes/no.
export function SafetyQuestion({ value, onChange, labelledBy, describedBy }: Props) {
  const { t } = useI18n();
  return (
    <div className="sx-topics sx-safety-choice" role="radiogroup" aria-labelledby={labelledBy} aria-describedby={describedBy}>
      <button type="button" role="radio" aria-checked={value === true} className={`sx-tile${value === true ? ' active' : ''}`} onClick={() => onChange(true)}>
        <span className="emoji" aria-hidden="true">🙋</span>
        <span>{t['r6.ci.safetyYes']}</span>
        {value === true && <span className="tick" aria-hidden="true">✓</span>}
      </button>
      <button type="button" role="radio" aria-checked={value === false} className={`sx-tile${value === false ? ' active' : ''}`} onClick={() => onChange(false)}>
        <span className="emoji" aria-hidden="true">🙅</span>
        <span>{t['r6.ci.safetyNo']}</span>
        {value === false && <span className="tick" aria-hidden="true">✓</span>}
      </button>
    </div>
  );
}
